import { FC, useState } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AlertDialog from 'app/components/AlertDialog';
import {
  COLOR_DISCLAIMER_BADGE_LABEL,
  COLOR_DISCLAIMER_TEXT,
  COLOR_POLICY_FAQ,
  hasColorDisclaimer,
} from 'app/constants/colorDisclaimer';

interface Props {
  productId?: number;
  /** Render text and badge in contrast color for use over dark backgrounds. */
  light?: boolean;
}

const ColorDisclaimer: FC<Props> = ({ productId, light }) => {
  const [faqOpen, setFaqOpen] = useState(false);

  if (!hasColorDisclaimer(productId)) return null;

  const color = light ? 'primary.contrastText' : 'text.secondary';

  return (
    <>
      <Box
        mt={1}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="center"
        columnGap={1}
        textAlign="center"
      >
        <Typography fontSize={13} color={color}>
          {COLOR_DISCLAIMER_TEXT}
        </Typography>
        <Link
          component="button"
          type="button"
          onClick={() => setFaqOpen(true)}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            fontSize: 13,
            fontWeight: 500,
            cursor: 'pointer',
            color,
            textDecorationColor: 'inherit',
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
          {COLOR_DISCLAIMER_BADGE_LABEL}
        </Link>
      </Box>

      <AlertDialog
        open={faqOpen}
        onClose={() => setFaqOpen(false)}
        title={COLOR_POLICY_FAQ.q}
        text={COLOR_POLICY_FAQ.a}
      />
    </>
  );
};

export default ColorDisclaimer;
